import { render, staticRenderFns } from "./SinglePersonIcon.vue?vue&type=template&id=e1b5caac&scoped=true"
import script from "./SinglePersonIcon.vue?vue&type=script&lang=js"
export * from "./SinglePersonIcon.vue?vue&type=script&lang=js"
import style0 from "./SinglePersonIcon.vue?vue&type=style&index=0&id=e1b5caac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b5caac",
  null
  
)

export default component.exports